<div class="flex flex-col gap-5 w-full h-full overflow-hidden">
  <div class="flex flex-row justify-between items-center">
    <div (click)="onHeaderClick()"
         class="flex flex-row font-medium text-lg gap-2 cursor-pointer hover:opacity-80 transition-opacity items-center">
      <div class="flex flex-row justify-start items-center w-4 h-8 rounded-lg text-base text-gray-900">
        <ng-content select="[card-icon]"></ng-content>
      </div>
      <ng-content select="[card-title]"></ng-content>
    </div>

    @if (tooltipText) {
      <div
        class="w-6 h-6 flex items-center justify-center cursor-pointer overflow-visible"
        [tooltip]="tooltipText"
        tooltipDirection="bottom">
        <fa-icon
          [icon]="faCircleQuestion"
          class="text-lg text-gray-200 pointer-events-none">
        </fa-icon>
      </div>
    }
  </div>

  <ng-content select="[card-content]"></ng-content>
</div>
